import { useLayoutEffect } from 'react';
import useContextContainer from './use-context-container.js';

const useLockCurrentContextScroll = (lock = true) => {
	const container = useContextContainer();
	useLayoutEffect(() => {
		if (container && lock) {
			container.classList.add('u-oh');
			return () => {
				container.classList.remove('u-oh');
			};
		}
	}, [container, lock]);
};

export default useLockCurrentContextScroll;
